var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('o-view',[_c('o-nav-bar',{attrs:{"title":"Actieve route","has-back-button":true}}),_c('o-route-details')],1)}
var staticRenderFns = []

export { render, staticRenderFns }